export function getConfig (config) {
  let environmentConfiguration = {
    "cloudinaryBaseUrl": "https://assets.icanet.se",
    "searchUrl": "https://iw01dazweweb002.azure.icacorp.net"
  }

  if (SSR_MODE && config) {
    environmentConfiguration = config
  } else if (window && window._vueContext && window._vueContext.envConfig) {
    environmentConfiguration = window._vueContext.envConfig
  }

  return environmentConfiguration
}
